module.exports = __webpack_public_path__ + "static/media/ris-icon.318fbd17.svg";